// extracted by mini-css-extract-plugin
export default {"checkboxCell":"checkbox_cell_checkboxCell__Qa0BQ"};